module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/269.f7297fd9.png";